import type { IUseAccess } from 'hooks/useAccess';
import { Button, IconAdd } from 'uikit';

import { useCallback, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';

import { CreateCatalogDialog } from './CreateCatalogDialog';
import { useGetCatalogTypes, useCreateCatalog, CREATE_CATALOG_FIELD_NAME } from './hooks';

export const CreateCatalog = ({
    updateCatalogList,
    catalogsRules,
}: {
    updateCatalogList: () => void;
    catalogsRules?: IUseAccess['catalogs'];
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const { control, handleSubmit, setValue } = useForm({
        criteriaMode: 'all',
        shouldUnregister: true,
    });

    const currentValue = useWatch({
        name: CREATE_CATALOG_FIELD_NAME,
        control,
    });

    const openModalHandler = useCallback(() => {
        setIsOpen(true);
    }, []);

    const closeModalHandler = useCallback(() => {
        setIsOpen(false);
    }, []);

    const { catalogTypes, getCatalogTypesStatus } = useGetCatalogTypes({ isOpen, setValue, currentValue });

    const { createCatalogHandler, createCatalogStatus } = useCreateCatalog({
        closeModalHandler,
        updateCatalogList,
    });

    const onSubmitHandler = useCallback(() => {
        handleSubmit((checkedValue: any) => {
            createCatalogHandler(checkedValue);
        })();
    }, [createCatalogHandler, handleSubmit]);

    return (
        <>
            <Button
                label="Создать справочник"
                iconLeft={IconAdd}
                onClick={openModalHandler}
                disabled={!catalogsRules?.canCreate}
            />

            {isOpen && (
                <CreateCatalogDialog
                    name={CREATE_CATALOG_FIELD_NAME}
                    control={control}
                    catalogTypes={catalogTypes}
                    getTypesStatus={getCatalogTypesStatus}
                    createCatalogStatus={createCatalogStatus}
                    onCloseHandler={closeModalHandler}
                    onConfirmHandler={onSubmitHandler}
                    isConfirmDisabled={!currentValue}
                />
            )}
        </>
    );
};

CreateCatalog.displayName = 'CreateCatalog';
